import { gql, useQuery } from '@apollo/client';

import { EIntutoIntegrationStatus } from '@/graphql-types/globalTypes';

import { IntutoLearningNavVisible_Query } from './graphql-types/IntutoLearningNavVisible_Query';

export const INTUTO_LEARNING_NAV_VISIBLE_QUERY = gql`
  query IntutoLearningNavVisible_Query {
    intutoIntegrationGetStatus {
      status
    }
  }
`;

export function useIntutoLearningNavVisible(): {
  isVisible: boolean;
  isLoading: boolean;
} {
  const { data, loading } = useQuery<IntutoLearningNavVisible_Query>(
    INTUTO_LEARNING_NAV_VISIBLE_QUERY,
    { fetchPolicy: 'cache-and-network' },
  );

  const status = data?.intutoIntegrationGetStatus?.status;
  const isVisible = status === EIntutoIntegrationStatus.INITIALIZED;
  const isLoading = loading && status == null;

  return { isVisible, isLoading };
}
